import monthlyPrices from './prices.json';
import cookie from 'react-cookies';
import {isEuMember} from '../../Application/Shared2/CountryUtil';
import {
  pageViewActionAllParams,
} from '../../Application/Shared/TrackActionService';

/**
* TODO
*/
export function initializePrices() {
  let country = cookie.load('geotargetly_country_code');
  const priceRef = document
      .querySelectorAll('.geotargetlygeocontent1560145173081');
  if (isEuMember(country)) {
    country = 'eu';
  }
  if (!monthlyPrices[country]) {
    country = 'default';
  }
  const countryObj = monthlyPrices[country];
  Array.from(priceRef).forEach((ref) => {
    ref.innerHTML = countryObj.cur_symbol+''+
    countryObj.price + ' /month';
  });
};
/**
* TODO
* @param {object} pageViewParameters
*/
export function trackPageView(pageViewParameters) {
  const pageViewTrackParam = {
    'pageKind': pageViewParameters.pageKind,
    'locale': pageViewParameters.locale,
    'courseSlug': pageViewParameters.courseSlug,
    'facultySlug': pageViewParameters.facultySlug,
  };
  pageViewActionAllParams(pageViewTrackParam);
};

/**
 *
 *
 * @export
 * @param {*} locale
 * @param {*} courseId
 * @return {*}
 */
export function getLocalizedSignupLink(locale, courseId) {
  const languagePath = ['en', 'en-in', 'en-ng'].includes(locale) ?
   '' : locale + '/';
  const signupURL = `/${languagePath}signup/?courseId=${courseId}`;
  return signupURL;
};

// For U.S user Single Course Lifetime
/**
 *
 *
 * @export
 * @param {*} locale
 * @param {*} courseId
 * @return {*}
 */
export function getLocalizedSignupLinkUS(locale, courseId) {
  const languagePath = ['en', 'en-in', 'en-ng'].includes(locale) ?
   '' : locale + '/';
  const signupURL =
  `/${languagePath}signup/?courseId=${courseId}&offer_code=LT-BASIC`;
  return signupURL;
};

/**
 *
 *
 * @export
 * @param {*} locale
 * @param {*} link
 * @return {*}
 */
export function getLocalizedPageLink(locale, link = '') {
  const languagePath = ['en', 'en-in', 'en-ng'].includes(locale) ?
   '' : `/${locale}`;
  const pageLink = `${languagePath}${link}`;
  return pageLink;
}

/**
 *
 *
 * @export
 * @return {*}
 */
export function getMonthlySubscriptionPrice() {
  let country = cookie.load('geotargetly_country_code');
  const priceRef = document
      .querySelectorAll('.geotargetlygeocontent1560145173081');
  if (isEuMember(country)) {
    country = 'eu';
  }
  if (!monthlyPrices[country]) {
    country = 'default';
  }
  const countryObj = monthlyPrices[country];
  return countryObj;
}

/**
 * Creates and return canonical page nodes
 * assuming same path
 * @export
 * @param {*} path
 * @return {*}
 */
export function getCanonicalPages(path) {
  return {
    edges: ['en', 'en-in', 'en-ng'].map((locale) => {
      return {
        node: {
          publish_details: {
            locale,
          },
          url: path,
        },
      };
    }),
  };
}


/**
 * Toggle visibility of chat bot
 * @export
 * @param {boolean} visible
 */
export function setChatBotVisibility(visible) {
  try {
    const fabIframe = Array.from(document.getElementsByName('fab')).
        find((elem) => elem.tagName.toLowerCase() === 'iframe' );
    if (fabIframe) {
      fabIframe.hidden = !visible;
    }
    const chatIframe = Array.from(document.getElementsByName('webchat')).
        find((elem) => elem.tagName.toLowerCase() === 'iframe' );
    if (chatIframe) {
      chatIframe.hidden = !visible;
    }
  } catch (error) {
    console.log('setChatBotVisibility error', visible, error);
  }
}
